<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/o05eR7/tc-custom/9781633530928.jpg?1734695543250" alt="This image is the cover for the book New Grad Job Hacks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">New Grad Job Hacks
      </h1>
      <p class="bookDescription body article font2">
        <b>The founder of YouTube’s largest career channel, <i>Engineered Truth</i>, provides “practical how-tos on how to navigate life after college” (Tam Pham, bestselling author of <i>How to Network</i>).</b><br/><br/>Just graduated college? Still waiting for the perfect job that was supposed to be dropped in your lap after the graduation ceremony? Wondering when you get to start that marvelous and rewarding career you always dreamed about? <i>New Grad Job Hacks</i> is here to help. Career expert YouTuber and blogger Matt Tran takes you step-by-step through how to make the most of your degree. Tran’s channel, <i>Engineered Truth</i>, has helped thousands of new grads figure out their best paths to fulfilling careers. In <i>New Grad Job Hacks</i>, Tran guides us from job fairs to social media, from internships to job shadowing and teaches how to research companies, interview, negotiate, and get that job offer you always wanted.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Matt Tran
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Mango Media Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c53ebb94